<template>
    <div class="pickuplist-container show-on-top">
        <div class="pickuplist-header">
            <div class="pickuplist-headline">
                <h3>{{ $t('child_checkin_pickupPermissions') }}</h3>
                <div
                    class="pickuplist-close"
                    @click="$emit('hide-pickup-permission')"
                >
                    <i
                        class="icon-times-circle-o"
                    ></i>
                </div>
            </div>
        </div>
        <div class="pickup-list">
            <div
                v-for="parent in pickuplist"
                class="parent-container"
            >
                <div class="parent-name">
                    {{ parent.name }}
                </div>
                <div class="parent-avatar default">
                    <img :src="parent.avatar" />
                </div>
            </div>
            <div
                v-if="pickuplist.length <= 0"
                class="parent-container-missing"
            >
                {{ $t('Es sind keine Abholberechtigten für dieses Kind hinterlegt.') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        pickuplist: {
            type: Array,
            required: true,
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss">
.tabletView {
    .show-on-top {
        z-index: 10;
        position: fixed !important;
        margin-left: calc((100% - 300px) - 50%);
        top: 15%;
    }

    .pickuplist-container {
        left: 270px;
        z-index: 10;
        width: 400px;
        height: calc(100% - 200px);
    }

    .pickuplist-header {
        color: white;
        border-radius: 5px;
        line-height: 50px;
    }

    .pickuplist-headline {
        display: flex;
    }

    .pickuplist-headline h3 {
        margin: auto;
    }

    .pickuplist-close {
        font-size: 25px;
        cursor: pointer;
    }

    .pickup-list {
        overflow-x: hidden;
        overflow-y: auto;
        height: calc(100% - 60px);
    }

    .parent-container {
        position: relative;
        margin-bottom: 25px;
    }

    .parent-container-missing {
        color: white
    }

    .parent-avatar {
        position: relative;
        overflow: hidden;
        border-radius: 50%;
        border: 3px solid;
        background-color: black;
    }

    .parent-avatar.default {
        width: 100px;
        height: 100px;
        border-color: #0071ad;
        margin: 10px;
    }

    .parent-avatar img {
        -webkit-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        position: absolute;
        left: 50%;
        top: 50%;
        width: 100px;
        height: auto;
    }

    .parent-name {
        background: white;
        width: 300px;
        height: 50px;
        line-height: 50px;
        position: absolute;
        top: 50px;
        left: 62px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-bottom: 3px solid #0071ad;
        padding-left: 70px;
    }
}
</style>
